import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "cla-left-rail-section-heading",
  templateUrl: "left-rail-section-heading.component.html",
  styleUrls: ["./left-rail-section-heading.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LeftRailSectionHeadingComponent {}
